import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id"];
import { useAxiosClient } from '../hooks';
import { createQueryKey, sanitizeParams } from '../utils';
import useQuery from './useQuery';
export default function useFindById(variant, basePath, _ref, options) {
  let {
      id
    } = _ref,
    params = _objectWithoutPropertiesLoose(_ref, _excluded);
  const axiosClient = useAxiosClient();
  async function queryFn() {
    const url = variant.replace('{basePath}', basePath).replace('{id}', id);
    const response = await axiosClient.get(url, {
      params: sanitizeParams(params)
    });
    return response.data;
  }
  const queryKey = createQueryKey(basePath, variant, params, [id]);
  return useQuery(queryKey, queryFn, options);
}